window.addEventListener("DOMContentLoaded", function(){
    const logoContainers = document.querySelectorAll(".ns-logo-carousel__element");
    logoContainers.forEach((carouselContainer) => {
        logoCarouselInit(carouselContainer);
    });
    if(logoContainers.length>0){
        document.addEventListener("scroll", getBodyBackgroundColorToCarouselShades);
        setTimeout(getBodyBackgroundColorToCarouselShades,50);
    }
});

function logoCarouselInit(carouselContainer){
    const carouselBar = carouselContainer.querySelector(".ns-logo-carousel__bar");
    const carouselBarWidht = carouselBar.offsetWidth;
    for (let i = 0; i < 4; i++) {
        carouselContainer.insertAdjacentHTML("beforeend", carouselBar.outerHTML);
    }
    carouselContainer.style.setProperty('--transformOffset', `-${carouselBarWidht}px`);
}
function getBodyBackgroundColorToCarouselShades(){
    const bodyBg = document.querySelector("body").style.backgroundColor;
    if(!bodyBg){
        return;
    }
    const bodyBgHex = convertRgb(bodyBg);
    const logoElements = document.querySelectorAll(".ns-logo-carousel__element-column");
    logoElements.forEach((logoElement) => {
        const leftShade = `linear-gradient(270deg, rgba(${bodyBgHex}, 0) 0%, rgba(${bodyBgHex}, 0.3) 20%, rgba(${bodyBgHex}, 0.55) 37.5%, rgba(${bodyBgHex}, 1) 100%)`;
        const righrShade = `linear-gradient(270deg, rgba(${bodyBgHex}, 1) 0%, rgba(${bodyBgHex}, 0.55) 20%, rgba(${bodyBgHex}, 0.3) 37.5%, rgba(${bodyBgHex}, 0) 100%)`;
        logoElement.style.setProperty("--left-shade", leftShade);
        logoElement.style.setProperty("--right-shade", righrShade);
    });
}
function convertRgb(rgb) {
    if (rgb === "rgba(0, 0, 0, 0)"){
        rgb = "rgb(255, 255, 255)";
    }
    rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(,\s*(\d+))*\)$/);
    return `${rgb[1]}, ${rgb[2]}, ${rgb[3]}`;
}

